export default "__VITE_ASSET__BtuQygIG__"